"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _marketing = require("@/api/marketing");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var _default = exports.default = {
  name: 'CouponList',
  props: {
    checkedIds: {
      type: Array,
      default: []
    },
    allCheck: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      listLoading: true,
      tableData: {
        data: [],
        total: 0
      },
      tableFrom: {
        page: 1,
        limit: 10,
        keywords: ''
      },
      multipleSelection: {
        coupon_id: ''
      },
      templateRadio: 0
    };
  },
  filters: {
    receiveType: function receiveType(val) {
      var typeObj = {
        1: '手动领取',
        2: '商品赠送券',
        3: '平台自动发放'
      };
      return typeObj[val];
    }
  },
  mounted: function mounted() {
    this.getList(1);
  },
  methods: {
    rowStyle: function rowStyle(_ref) {
      var row = _ref.row,
        rowIndex = _ref.rowIndex;
      Object.defineProperty(row, 'rowIndex', {
        value: rowIndex,
        writable: true,
        enumerable: false
      });
    },
    rowClick: function rowClick(row) {
      this.multipleSelection = {
        coupon_id: row.id
      };
      this.templateRadio = row.id;
    },
    getTemplateRow: function getTemplateRow(row) {
      this.multipleSelection = {
        coupon_id: row.id
      };
    },
    // 发送优惠券
    send: function send(id) {
      var that = this;
      that.$confirm('确定要发送优惠券吗？发送优惠券后将无法恢复，请谨慎操作！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var params = {
          couponId: id,
          // is_all: that.allCheck ? 1 : 0,
          uidList: that.checkedIds
        };
        (0, _marketing.couponSendApi)(params).then(function (res) {
          that.$message.success('发送成功');
          that.$emit('sendSuccess');
        }).catch(function (res) {
          that.$message.error(res);
        });
      }).catch(function (action) {
        that.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    filter: function filter(data) {
      for (var key in data) {
        if (data[key] === '') {
          delete data[key];
        }
      }
      return data;
    },
    // 列表
    getList: function getList(num) {
      var _this = this;
      this.listLoading = true;
      this.tableFrom.page = num ? num : this.tableFrom.page;
      (0, _marketing.canSendListApi)(this.tableFrom).then(function (res) {
        _this.tableData.data = res.list;
        _this.tableData.total = res.total;
        _this.listLoading = false;
      }).catch(function (res) {
        _this.listLoading = false;
        _this.$message.error(res.message);
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList('');
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList('');
    }
  }
};